module.exports = __webpack_public_path__ + "img/产·品·中·心.a9962ee9.png";